/* eslint no-console:0 no-debugger:0 */

import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Card,
  CardActions,
  CardContent,
  Typography,
  Button,
  Grid,
  Link,
} from '@material-ui/core';
import GA from 'react-ga4';
import IntroductionMain from './IntroductionMain';
import config from '../config';
import { getAppKey, isMobileAppMode } from '../utils/localStorage';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'underline',
    '&:hover': {
      color: theme.hrefLink.textColor,
      textDecoration: 'underline',
    },
    '&:visited': {
      color: theme.hrefLink.textColor,
      textDecoration: 'underline',
    },
  },
  headlineContainer: {
    padding: theme.spacing(2),
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  headline: {
    width: 'fit-content',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.info.contrastText,
    boxShadow: 'none',
  },
  loginContainer: {
    display: 'flex',
    backgroundColor: 'theme.palette.primary.main',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignContent: 'center',
  },
  loginButtonContainer: {
    width: '250px',
    margin: theme.spacing(2),
  },
  loginButton: {
    width: '100%',
    textTransform: 'none',
    justifyContent: 'center',
    borderRadius: 36,
    color: theme.typo.themeColour,
    backgroundColor: theme.palette.component.loginButton,
  },
  google: {
    backgroundImage: 'url(data:image/svg+xml;base64,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)',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    width: 50,
    height: 50,
  },
  apple: {
    backgroundImage: 'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMTcwcHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE3MCAxNzAiIHZlcnNpb249IjEuMSIgaGVpZ2h0PSIxNzBweCI+PGcgaWQ9IkFwcGxlX2xvZ29fYmxhY2siIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+IDxwYXRoIGQ9Im0xNTAuMzcgMTMwLjI1Yy0yLjQ1IDUuNjYtNS4zNSAxMC44Ny04LjcxIDE1LjY2LTQuNTggNi41My04LjMzIDExLjA1LTExLjIyIDEzLjU2LTQuNDggNC4xMi05LjI4IDYuMjMtMTQuNDIgNi4zNS0zLjY5IDAtOC4xNC0xLjA1LTEzLjMyLTMuMTgtNS4xOTctMi4xMi05Ljk3My0zLjE3LTE0LjM0LTMuMTctNC41OCAwLTkuNDkyIDEuMDUtMTQuNzQ2IDMuMTctNS4yNjIgMi4xMy05LjUwMSAzLjI0LTEyLjc0MiAzLjM1LTQuOTI5IDAuMjEtOS44NDItMS45Ni0xNC43NDYtNi41Mi0zLjEzLTIuNzMtNy4wNDUtNy40MS0xMS43MzUtMTQuMDQtNS4wMzItNy4wOC05LjE2OS0xNS4yOS0xMi40MS0yNC42NS0zLjQ3MS0xMC4xMS01LjIxMS0xOS45LTUuMjExLTI5LjM3OCAwLTEwLjg1NyAyLjM0Ni0yMC4yMjEgNy4wNDUtMjguMDY4IDMuNjkzLTYuMzAzIDguNjA2LTExLjI3NSAxNC43NTUtMTQuOTI1czEyLjc5My01LjUxIDE5Ljk0OC01LjYyOWMzLjkxNSAwIDkuMDQ5IDEuMjExIDE1LjQyOSAzLjU5MSA2LjM2MiAyLjM4OCAxMC40NDcgMy41OTkgMTIuMjM4IDMuNTk5IDEuMzM5IDAgNS44NzctMS40MTYgMTMuNTctNC4yMzkgNy4yNzUtMi42MTggMTMuNDE1LTMuNzAyIDE4LjQ0NS0zLjI3NSAxMy42MyAxLjEgMjMuODcgNi40NzMgMzAuNjggMTYuMTUzLTEyLjE5IDcuMzg2LTE4LjIyIDE3LjczMS0xOC4xIDMxLjAwMiAwLjExIDEwLjMzNyAzLjg2IDE4LjkzOSAxMS4yMyAyNS43NjkgMy4zNCAzLjE3IDcuMDcgNS42MiAxMS4yMiA3LjM2LTAuOSAyLjYxLTEuODUgNS4xMS0yLjg2IDcuNTF6bS0zMS4yNi0xMjMuMDFjMCA4LjEwMjEtMi45NiAxNS42NjctOC44NiAyMi42NjktNy4xMiA4LjMyNC0xNS43MzIgMTMuMTM0LTI1LjA3MSAxMi4zNzUtMC4xMTktMC45NzItMC4xODgtMS45OTUtMC4xODgtMy4wNyAwLTcuNzc4IDMuMzg2LTE2LjEwMiA5LjM5OS0yMi45MDggMy4wMDItMy40NDYgNi44Mi02LjMxMTMgMTEuNDUtOC41OTcgNC42Mi0yLjI1MTYgOC45OS0zLjQ5NjggMTMuMS0zLjcxIDAuMTIgMS4wODMxIDAuMTcgMi4xNjYzIDAuMTcgMy4yNDA5eiIvPjwvZz48L3N2Zz4K)',
    backgroundSize: '60%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    filter: 'invert(100%)',
    width: 50,
    height: 50,
  },
  microsoft: {
    backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAPFBMVEXxURuAzCgAre/7vAn////xTxfxVCDyWiyFzjSEzS8Ir+8dsfD7vxz7vhLyWCfxTRLyYjeL0D4ptPD7wSkDOo23AAABHUlEQVR4nO3PSRKCQBAAwVZAYFhc+P9fPToXrk2MkfWBioxHJDWM/a/pltUchISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhOfCGJJ67hcJxz2rVyV8z1NW0f97hO1H2H6E7UfYfoTtF0vJ6lNtj23NKso9q1IJ1y6tROFyiXAjJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkPBd+AR2XhmxGp3JaAAAAAElFTkSuQmCC)',
    backgroundSize: '60%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    // filter: 'invert(100%)',
    width: 50,
    height: 50,
  },
  introductionContainer: {
    width: '100%',
    padding: theme.spacing(1),
    paddingTop: theme.spacing(10),
  },
  typo: {
    color: theme.palette.info.contrastText,
  },
  footer: {
    marginTop: theme.spacing(10),
    borderTop: `1px solid ${theme.palette.primary.light}`,
  },
}));

function Copyright(props) {
  const classes = useStyles();

  return (
    <Typography variant="body2" color="textSecondary" align="center" {...props}>
      {'Designed by '}
      <Link className={classes.link} color="textPrimary" href="https://cnr.ai">
        C&amp;R
      </Link>
      {' in '}
      <Link className={classes.link} color="textPrimary" href="https://en.wikipedia.org/wiki/Cambridge">
        Cambridge UK
      </Link>
    </Typography>
  );
}

const LoginForm = props => {
  const classes = useStyles();
  const {
    onSuccess,
    handleSignInWithMicrosoft,
    useCase,
    handleSignInWithAppKey,
  } = props;
  const query = new URLSearchParams(useLocation().search);
  const appKey = query.get(config.APP.QUERY_KEY) || getAppKey(); // The app-key in query should override the key in storage

  useEffect(() => {
    // TODO: should we use state and nonce to improve security?
    // const state = uuid.v4();
    // const nonce = uuid.v4();
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: 'ai.cnr.studio',
        scope: 'name email',
        redirectURI: `https://${document.location.host}/auth/apple/return`,
        usePopup: true,
        // state,
        // nonce,
      });
    }

    window.edgeAiAuthCallback = data => {
      if (data.op === 'auth-success') {
        onSuccess(data.user);
      }

      if (data.op === 'auth-error-google') {
        alert('Authentication error is received from Google.  Please try again.');
      }
      if (data.op === 'auth-error-microsoft') {
        alert('Authentication error is received from Microsoft.  Please try again.');
      }
    };

    (async () => {
      try {
        const res = await fetch('/auth/cloudflare/callback');
        const json = await res.json();
        if (json.appKey) {
          if (window.location.port === '' || window.location.port === '443') {
            handleSignInWithAppKey(`${json.appKey}-443`);
          }
          else {
            handleSignInWithAppKey(json.appKey);
          }
        }
      }
      catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const signInWithApple = async () => {
    GA.event({ category: 'click', action: 'apple_sign_in' });

    if (isMobileAppMode()) {
      // console.debug('mobile app mode');
      window.webkit.messageHandlers.appAppleSignIn.postMessage({});
      return true;
    }

    const data = await window.AppleID.auth.signIn();
    const res = await fetch('/auth/apple/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    const profile = await res.json();
    onSuccess(profile);

    return true;
  };

  const signInWithGoogle = async () => {
    GA.event({ category: 'click', action: 'google_sign_in' });

    if (isMobileAppMode()) {
      // console.debug('mobile app mode');
      window.webkit.messageHandlers.appGoogleSignIn.postMessage({});
      return true;
    }

    // console.debug('not mobile app mode');
    const provider = 'google';
    const width = 600;
    const height = 600;
    const left = (window.innerWidth / 2) - (width / 2);
    const top = (window.innerHeight / 2) - (height / 2);
    const url = `/auth/${provider}`;

    return window.open(url, '',
      `toolbar=no, location=no, directories=no, status=no, menubar=no,
      scrollbars=no, resizable=no, copyhistory=no, width=${width},
      height=${height}, top=${top}, left=${left}`);
  };

  const handleClickLogin = provider => async () => {
    switch (provider) {
      case 'apple':
        return signInWithApple();
      case 'google':
        return signInWithGoogle();
      case 'microsoft':
        return handleSignInWithMicrosoft();
      case 'app-key':
        return handleSignInWithAppKey(appKey);
      default:
        return null;
    }
  };

  const renderLoginButtons = () => {
    if (appKey && appKey in config.APP.PROFILES) {
      const profile = config.APP.PROFILES[appKey];
      return (
        <Grid item className={classes.loginButtonContainer}>
          <Button
            className={classes.loginButton}
            variant="outlined"
            onClick={handleClickLogin('app-key')}
          >
            {profile.LOGIN_BUTTON_TEXT}
          </Button>
        </Grid>);
    }

    return <>
      {useCase === 'general'
        ? <Grid item className={classes.loginButtonContainer}>
          <Button
            className={classes.loginButton}
            variant="outlined"
            onClick={handleClickLogin('google')}
          >
            <div className={classes.google} />
            Sign in with Google
          </Button>
        </Grid>
        : false
      }
      {(!isMobileAppMode() && (useCase === 'general' || useCase === 'azure-signup'))
        ? <Grid item className={classes.loginButtonContainer}>
          <Button
            className={classes.loginButton}
            variant="outlined"
            onClick={handleClickLogin('microsoft')}
          >
            <div className={classes.microsoft} />
            Sign in with Microsoft
          </Button>
        </Grid>
        : false
      }
      {useCase === 'general'
        ? <Grid item className={classes.loginButtonContainer}>
          <Button
            className={classes.loginButton}
            variant="outlined"
            onClick={handleClickLogin('apple')}
          >
            <div className={classes.apple} />
            Sign in with Apple
          </Button>
        </Grid>
        : false
      }
    </>;
  };

  return (
    <Grid container className={classes.root}>

      <Grid item xs={12} className={classes.headlineContainer}>
        <Card className={classes.headline}>
          <CardContent>
            {/* {/* <img src="/static/images/logo.png" style={{
            width: 200,
          }} /> */}
            <br />
            <br />
            <Typography variant="h4">EdgeAI Studio</Typography>
            <br />
            <Typography>A low-code AI platform.</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid
        item
        container
        className={classes.loginContainer}
        xs={12} sm={12}
      >
        {renderLoginButtons()}
      </Grid>

      {/* <Grid item className={classes.introductionContainer}>
        <IntroductionMain />
      </Grid> */}

      <Container
        maxWidth="md"
        component="footer"
        className={classes.footer}
      >
        <Grid container spacing={4} justifycontent="space-evenly">
          <Grid item xs={6} sm={3} key="contact">
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography>
              <Link className={classes.link} href="mailto:support@cnr.ai" color="textPrimary">Contact support</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="mailto:sales@cnr.ai" color="textPrimary">Contact sales</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="tel:+441223969268" color="textPrimary">Call sales: +44 1223 969268</Link>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3} key="resources">
            <Typography variant="h6" gutterBottom>
              Resources
            </Typography>
            <Typography>
              <Link className={classes.link} href="//docs.cnr.ai" color="textPrimary">Docs</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="https://discord.com/invite/FsX5aAn5bz" color="textPrimary">Community</Link>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3} key="legal">
            <Typography variant="h6" gutterBottom>
              Legal
            </Typography>
            <Typography>
              <Link className={classes.link} href="//docs.cnr.ai/legal/terms-of-service.html" color="textPrimary">Terms of Service</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="//docs.cnr.ai/legal/acceptable-use-policy.html" color="textPrimary">Acceptable Use Policy</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="//docs.cnr.ai/legal/privacy-policy.html" color="textPrimary">Privacy Policy</Link>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3} key="about-us">
            <Typography variant="h6" gutterBottom>
              About us
            </Typography>
            <Typography>
              <Link className={classes.link} href="//cnr.ai" color="textPrimary">Home</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="//cnr.ai/career/" color="textPrimary">Career</Link>
            </Typography>
            <Typography>
              <Link className={classes.link} href="//cnr.ai/contact/" color="textPrimary">Contact us</Link>
            </Typography>
          </Grid>
        </Grid>
        <Copyright style={{ marginTop: 8 * 10 }} />
      </Container>
    </Grid>
  );
};

export default LoginForm;
